import './styles.css';

export default function Checkbox({ label, isChecked, onCheck }) {
  const checkboxId = `checkbox-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div 
      className="onboarding-checkbox"
    >
      <input 
        type="checkbox"
        id={checkboxId} 
        checked={isChecked} 
        onChange={onCheck}
      />
      <label htmlFor={checkboxId} dangerouslySetInnerHTML={{ __html: label }}/>
    </div>
  );
}